import BaseDataObject from './BaseDataObject';
import Money from './Money';

export default class MyDividendInformation extends BaseDataObject {
  setAllCorrect(v) {
    return this.setObject('allCorrect', v);
  }

  setAllCorrectExceptOne(v) {
    return this.setObject('allCorrectExceptOne', v);
  }

  setAllCorrectExceptTwo(v) {
    return this.setObject('allCorrectExceptTwo', v);
  }

  setBreakdown(v) {
    this.setObjects('breakdown', v);
  }

  setTotalSum(v) {
    return this.setObject('totalSum', v);
  }

  getAllData() {
    return [
      this.getAllCorrect(),
      this.getAllCorrectExceptOne(),
      this.getAllCorrectExceptTwo(),
    ];
  }

  getAllCorrect() {
    return this.getObject('allCorrect', MyDividendsRow);
  }

  getAllCorrectExceptOne() {
    return this.getObject('allCorrectExceptOne', MyDividendsRow);
  }

  getAllCorrectExceptTwo() {
    return this.getObject('allCorrectExceptTwo', MyDividendsRow);
  }

  getBreakdown() {
    return this.getObjects('breakdown', MyDividendsRow);
  }

  getTotalSum() {
    return this.getObject('totalSum', Money);
  }

  getSubmitPrice() {
    return this.getObject('stake', Money);
  }

  getNetResult() {
    return this.getObject('profit', Money);
  }

  getCheckRikstoto() {
    return this.getBoolean('checkRikstoto');
  }
}

class MyDividendsRow extends BaseDataObject {
  getNrOfRows() {
    return this.getFloat('nrOfRows');
  }

  getPartSum() {
    return this.getObject('partSum', Money);
  }

  getPrizeGroup() {
    return this.getString('prizeGroup');
  }
}
